import { urls } from "app/constants";
import { dtoReg, dtoRegEmail } from "app/utils/dto";
import { path } from "ramda";
import { axiosBase } from "./_api";

export const apiReg = (
  params: any,
  success: any,
  unsuccess: any,
  setErrors: any
) => {
  axiosBase({
    url: urls.reg,
    method: "post",
    data: dtoReg(params),
  })
    .then(success)
    .catch((error) => {
      if (
        error.response &&
        error.response.data &&
        error.response.status === 400
      ) {
        // console.log("API REG ERROR 400", error);

        let fieldErr: any = path(["response", "data", "errors"], error) || {};

        if (fieldErr.email) {
          fieldErr.email = fieldErr.email.map((e: string) => {
            if (e === "unique") return "Email уже зарегистрирован";
            return "n";
          });
        }

        if (fieldErr.code) {
          fieldErr.code = fieldErr.code.map((e: string) => {
            if (e === "invalid_code") return "Неверный код";
            return "n";
          });
        }

        if (fieldErr.name) {
          fieldErr.name = fieldErr.name.map((e: string) => {
            if (e === "blank") return "Введи имя";
            return "n";
          });
        }

        if (fieldErr.personnel_number) {
          fieldErr.prNumber = fieldErr.personnel_number.map((e: string) => {
            if (e === "does_not_exist")
              return "Табельный номер не найден или уже используется";
            if (e === "already_exists")
              return "Табельный номер не найден или уже используется";
            return "n";
          });
        }

        if (fieldErr.password) {
          fieldErr.password = fieldErr.password.map((e: string) => {
            if (e === "password_too_common") return "Пароль слишком простой";
            return "n";
          });
        }

        // console.log(fieldErr);
        setErrors(fieldErr);
      }
      return unsuccess(error);
    });
};

export const apiRegEmail = (
  params: any,
  success: any,
  unsuccess: any,
  setErrors: any
) => {
  axiosBase({
    url: urls.regEmail,
    method: "post",
    data: dtoRegEmail(params),
  })
    .then(success)
    .catch((error) => {
      if (
        error.response &&
        error.response.data &&
        error.response.status === 400
      ) {
        // console.log("API REG ERROR 400", error);

        let fieldErr: any = path(["response", "data", "errors"], error) || {};

        if (fieldErr.email) {
          fieldErr.email = fieldErr.email.map((e: string) => {
            if (e === "unique") return "Email уже зарегистрирован";
            if (e === "already_exists") return "Email уже зарегистрирован";
            return "Ошибка отправки";
          });
        }

        // console.log(fieldErr);
        setErrors(fieldErr);
      }
      return unsuccess(error);
    });
};
